import { NgModule } from 'ng-metadata/core';
import {AcquisitionRequest} from './acquisitionRequest';
import {CallslipRequest} from './callslipRequest';
import {HoldRequest} from './holdRequest';
import {IllRequest} from './illRequest';
import {PhotocopyRequest} from './photocopyRequest';
import {RecallRequest} from './recallRequest';
import {ShortLoanRequest} from './shortLoanRequest';
import {UBRequest} from './ubRequest';
import {AlmaRequestTypeModule} from './alma/almaRequestType.module';

@NgModule({
    declarations: [],
    providers: [
        AcquisitionRequest,
        CallslipRequest,
        HoldRequest,
        IllRequest,
        PhotocopyRequest,
        RecallRequest,
        ShortLoanRequest,
        UBRequest
    ],
    imports:[
        AlmaRequestTypeModule
    ]
})
export class RequestTypesModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/requestTypes.module.ts